module.exports = __webpack_public_path__ + "static/media/applicantPerson.5502cd2c.jpg";